/* Visual gallery and sharing only. Native theme components own all commerce. */
(() => {
  function init(root) {
    if (root.dataset.galleryReady) return; root.dataset.galleryReady = 'true';
    const labels = JSON.parse(root.querySelector('[data-gallery-labels]').textContent);
    const slides = [...root.querySelectorAll('[data-slide]')], gallery = root.querySelector('.sl-gallery');
    const imageDialog = root.querySelector('[data-image-dialog]');
    let index = 0, down = null, scale = 1;
    const showImage = n => {
      index = (n + slides.length) % slides.length;
      slides.forEach((slide, i) => { slide.hidden = i !== index; });
      root.querySelectorAll('[data-gallery-index]').forEach(button => button.setAttribute('aria-pressed', String(Number(button.dataset.galleryIndex) === index)));
      root.querySelector('[data-gallery-caption]').textContent = labels[index];
      root.querySelector('[data-gallery-count]').textContent = `${index + 1} / ${slides.length}`;
      window.solarPhotos?.(slides[index]);
    };
    root.querySelectorAll('[data-gallery-step]').forEach(button => button.addEventListener('click', () => showImage(index + Number(button.dataset.galleryStep))));
    root.querySelectorAll('[data-gallery-index]').forEach(button => button.addEventListener('click', () => showImage(Number(button.dataset.galleryIndex))));
    gallery.addEventListener('pointerdown', event => { if (!event.target.closest('button')) down = {x:event.clientX,y:event.clientY}; });
    gallery.addEventListener('pointerup', event => {
      if (!down || event.target.closest('button')) { down = null; return; }
      const dx = event.clientX - down.x, dy = event.clientY - down.y;
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) * 1.4) showImage(index + (dx < 0 ? 1 : -1));
      else if (Math.abs(dx) < 10 && Math.abs(dy) < 10) openZoom();
      down = null;
    });
    gallery.addEventListener('pointercancel', () => { down = null; });
    function openZoom() {
      scale = 1; const clone = slides[index].cloneNode(true); clone.hidden = false;
      clone.querySelectorAll('img').forEach(img => { if (img.dataset.solarSrcset) img.srcset=img.dataset.solarSrcset;if(img.dataset.solarSrc)img.src=img.dataset.solarSrc; });
      imageDialog.querySelector('.sl-image-zoom-content').replaceChildren(clone);
      if (!imageDialog.open) imageDialog.showModal();
    }
    root.querySelector('[data-zoom-open]').addEventListener('click', openZoom);
    imageDialog.querySelectorAll('[data-image-scale]').forEach(button => button.addEventListener('click', () => {
      scale = Math.max(.75, Math.min(3, scale + Number(button.dataset.imageScale)));
      imageDialog.querySelector('.sl-slide').style.transform = `scale(${scale})`;
    }));
    imageDialog.addEventListener('keydown', event => { if (['ArrowLeft','ArrowRight'].includes(event.key)) { event.preventDefault(); showImage(index + (event.key === 'ArrowLeft' ? -1 : 1)); openZoom(); } });
    // Observe the native picker for gallery presentation; do not alter forms or variants.
    root.querySelector('variant-selects')?.addEventListener('change', event => {
      const choices = [...root.querySelectorAll('variant-selects input[type=radio]')];
      const selected = choices.indexOf(event.target); if (selected >= 0) showImage(selected + 1);
    });
    showImage(0);
  }
  function initFooter() {
    const data = document.querySelector('[data-sl-share]');
    if (!data || data.dataset.ready) return; data.dataset.ready = 'true';
    const settings = JSON.parse(data.textContent), dialog = document.querySelector('[data-share-dialog]');
    const input = dialog.querySelector('input'); input.value = settings.url;
    dialog.querySelector('[data-share-copy]').addEventListener('click', async () => {
      const status = dialog.querySelector('[data-share-status]');
      try { await navigator.clipboard.writeText(settings.url); status.textContent=settings.copied; }
      catch { status.textContent=settings.manual;input.focus();input.select(); }
    });
    document.querySelector('[data-copy-product]').addEventListener('click', () => { dialog.querySelector('[data-share-instruction]').textContent=settings.manual;dialog.querySelector('[data-platform-open]').hidden=true;dialog.showModal(); });
    document.querySelectorAll('[data-platform]').forEach(button => button.addEventListener('click', () => {
      dialog.querySelector('[data-share-instruction]').textContent=settings[button.dataset.platform];
      const link=dialog.querySelector('[data-platform-open]');link.href=button.dataset.platformUrl;link.hidden=false;dialog.showModal();
    }));
  }
  function boot() {
    document.querySelectorAll('[data-solar-gallery]').forEach(init);initFooter();
    document.querySelectorAll('[data-dialog-close]').forEach(button=>{if(button.dataset.ready)return;button.dataset.ready='1';button.addEventListener('click',()=>button.closest('dialog').close());});
  }
  document.addEventListener('shopify:section:load',boot);
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot);else boot();
})();
